module.exports = __webpack_public_path__ + "static/media/Handbooks.39b7f421.svg";